<template>
  <div class="a-toggle" :class="{
    '--toNext': this.currentDisplay === this.next && this.currentDisplay !== this.current,
    '--toPrevious': this.currentDisplay === this.previous && this.currentDisplay !== this.current,
    '--toCurrent': this.currentDisplay !== this.current &&
      this.previousDisplay === this.previous &&
      this.nextDisplay === this.next,
  }">
    <span class="a-toggle__text --next">{{ this.previousDisplay | ellipse }}</span>
    <span class="a-toggle__text --current">{{ this.currentDisplay | ellipse }}</span>
    <span class="a-toggle__text --update">{{ this.current | ellipse }}</span>
    <span class="a-toggle__text --previous">{{ this.nextDisplay | ellipse }}</span>
    <span class="a-toggle__text --content">{{ this.size | ellipse  }}</span>
  </div>
</template>

<script>
export default {
  name: 'toggle',
  props: ['previous', 'current', 'next'],
  data() {
    return {
      previousDisplay: '',
      currentDisplay: '',
      nextDisplay: '',
    };
  },
  computed: {
    size() {
      return [
        this.previous,
        this.current,
        this.next,
      ].reduce((next, last) => (next.length > last.length ? next : last));
    },
  },
  filters: {
    ellipse(name = '') {
      return name.substring(0, 9) + (name.length > 9 ? '.' : '');
    },
  },
  mounted() {
    this.update();
  },
  methods: {
    update() {
      this.previousDisplay = this.previous;
      this.currentDisplay = this.current;
      this.nextDisplay = this.next;
    },
  },
  watch: {
    current() {
      const to = setTimeout(() => {
        this.update();
        clearTimeout(to);
      }, 1200);
    },
  },
};

</script>

<style lang="scss" scoped>
  .a-toggle{
    position: relative;
    overflow: hidden;

    &.--toNext {
      .--current {
        top: 100%;
        bottom: -100%;
        transition: all 1s;
      }
      .--next {
        bottom: 0;
        transition: bottom 1s;
      }
    }

    &.--toPrevious {
      .--current {
        top: -100%;
        bottom: 100%;
        transition: all 1s;
      }
      .--previous {
        top: 0;
        transition: top 1s;
      }
    }

    &.--toCurrent {
      .--current {
        top: -100%;
        bottom: 100%;
        transition: all 1s;
      }
      .--update {
        top: 0;
        transition: top 1s;
      }
    }

    &__text {
      display: block;
      padding: 12px 20px;
      right: 0;
      left: 0;
      white-space: nowrap;

      &.--content {
        opacity: 0;
      }

      &.--update {
        position: absolute;
        top: 100%;
        left: 0;
        transition: top 0s;
      }

      &.--current {
        position: absolute;
        bottom: 0;
        top: 0;
        transition: all 0s;
        opacity: 1;
      }

      &.--next {
        position: absolute;
        bottom: 100%;
        transition: bottom 0s;
      }

      &.--previous {
        position: absolute;
        top: 100%;
        left: 0;
        transition: top 0s;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Player/Channels/Toggle.vue